/**
 * Mount point for the "Run simulation" button, built in a separate PR. It
 * sits in the Test runs header; replace the body with the button. Renders
 * nothing until then.
 */
export function RunSimulationSlot() {
  return null;
}
